import { gql } from '@apollo/client'

export const addUserToWorkspace = gql`
  mutation AddUserToWorkspace($workspace: String!) {
    addUserToWorkspace(workspace: $workspace)
  }
`
